<div [appDisableInput]="caseLocked" class="caselock-no-events">
  <div class="sub-component-placeholder">
    <div class="sub-component-container">
      <div class="sub-title">{{"home-and-property-assistance-title" | translate}}</div>
      <app-text-box [name]="'home-and-property-assistance-label' | translate"
                    [maxTextLength]="1000"
                    [required]="false"
                    [(value)]="homeAndProperty.adviceGiven">
      </app-text-box>
    </div>
  </div>
  <div class="sub-component-placeholder">
    <div class="col-7 p-0">
      <app-sub-commitment-type
        [(commitmentType)]="homeAndProperty.commitmentType"
        [serviceOrderType]="serviceOrderType"
        [caseId]="caseId"
      ></app-sub-commitment-type>
    </div>
  </div>
  <div class="sub-component-placeholder">
    <app-durations
      [incidentId]="incidentId"
      [gopDatesSemiRequired]="false"
      [durations]="homeAndProperty.durations"
      [hideGOPDates]="false"
      [disableStartDate]="true"
      [disableEndDate]="true"
      [disableLocation]="true"
      [hideRoomAndRemark]="true"
      [hideAdd]="true"
      [unrestrictGopDates]="true"
      [altGopPeriodTitle]="'sub-durations-gop-period-title'"
      [defaultStartDate]="defaultStartDate"
      [defaultEndDate]="defaultEndDate"
    ></app-durations>
  </div>
  <div class="sub-component-placeholder"
       *ngIf="homeAndProperty.commitmentType && homeAndProperty.commitmentType.businessKey === CommitmentTypes.REQUEST_ASSISTANCE">
    <app-sub-gop-details
      [serviceTypeEnum]="ServiceTypeEnum.HOME_AND_PROPERTY"
      [templateFilter]="homeAndPropertyTemplatesFilter"
      [subGopDetails]="homeAndProperty.gopDetails"
      [hideItemsFields]="true"
    ></app-sub-gop-details>
  </div>
  <div class="sub-component-placeholder"
       *ngIf="homeAndProperty.commitmentType && homeAndProperty.commitmentType.businessKey === CommitmentTypes.REQUEST_ASSISTANCE">
    <app-GOP
      [caseId]="caseId"
      [serviceOrderExtension]="homeAndProperty"
      [supplier]="supplier"
      [stakeholders]="stakeholders"
      [serviceOrderTypeState]="serviceOrderTypeState"
    ></app-GOP>
  </div>
</div>
